import { SCROLL_ARIA_VALUE_MAX, SCROLL_ARIA_VALUE_MIN, SCROLL_BAR_CONTAINER_ID, SCROLL_BAR_LINE_ID, SCROLL_WIDTH_OFFSET, TABLE_PAGINATION_PIN_HEIGHT_VAR } from './constants';
const VALID_SCROLL_TAGS = ['DIV', 'TABLE', 'ARTICLE'];
export function getFirstScrollableElement(element) {
    const tags = VALID_SCROLL_TAGS.map((tag) => tag.toLowerCase()).join(', ');
    return Array.from(document.querySelectorAll(tags)).find((selector) => {
        return (selector.scrollHeight > selector.clientHeight &&
            (selector.contains(element) || (element === null || element === void 0 ? void 0 : element.contains(selector)) || element === selector));
    });
}
export function getWidestScrollableChild(element) {
    let widestScrollableChild = null;
    let maxScrollableWidth = 0;
    if (!element)
        return null;
    for (let i = 0; i < element.childNodes.length; i += 1) {
        const child = element.childNodes[i];
        if (child.nodeType === Node.ELEMENT_NODE) {
            const el = child;
            const childScrollableWidth = el.scrollWidth - el.clientWidth;
            if (childScrollableWidth > maxScrollableWidth && VALID_SCROLL_TAGS.includes(el.tagName)) {
                widestScrollableChild = el;
                maxScrollableWidth = childScrollableWidth;
            }
            const nested = getWidestScrollableChild(el);
            if (nested && nested.scrollWidth - nested.clientWidth > maxScrollableWidth) {
                widestScrollableChild = nested;
                maxScrollableWidth = nested.scrollWidth - nested.clientWidth;
            }
        }
    }
    if (maxScrollableWidth < SCROLL_WIDTH_OFFSET) {
        return null;
    }
    return widestScrollableChild;
}
export function getFirstScrollableChild(element) {
    if (!element)
        return null;
    if (element.scrollWidth > element.clientWidth) {
        return element;
    }
    for (let i = 0; i < element.children.length; i += 1) {
        const scrollableChild = getFirstScrollableChild(element.children[i]);
        if (scrollableChild) {
            return scrollableChild;
        }
    }
    return null;
}
export function findLastScrollableElement(elementParam) {
    var _a;
    if (!elementParam) {
        return null;
    }
    const scrollableChildren = [];
    function findScrollableChildrenRecursive(element) {
        const children = Array.from(element.children);
        for (let i = 0; i < children.length; i += 1) {
            const child = children[i];
            if (element.scrollWidth > element.clientWidth + SCROLL_WIDTH_OFFSET) {
                scrollableChildren.push(child);
            }
            else {
                findScrollableChildrenRecursive(child);
            }
        }
    }
    findScrollableChildrenRecursive(elementParam);
    return (_a = scrollableChildren[scrollableChildren.length - 1]) !== null && _a !== void 0 ? _a : null;
}
export function isElementVisible(el) {
    if (!el)
        return false;
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    return rect.top < windowHeight && rect.bottom > 0 && rect.left < windowWidth && rect.right > 0;
}
export function isElementBottomVisible(element) {
    if (!element)
        return false;
    const elementRect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return elementRect.bottom <= viewportHeight;
}
/**
 * Viewport-bottom offset for the fixed horizontal thumb so it sits above
 * pinned table pagination instead of overlapping it.
 */
export function getPaginationPinOffset(wrapper) {
    if (!wrapper)
        return 0;
    const tableRoot = wrapper.closest('.qmb-ui-table');
    if (!tableRoot)
        return 0;
    const raw = getComputedStyle(tableRoot).getPropertyValue(TABLE_PAGINATION_PIN_HEIGHT_VAR);
    const parsed = parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 0;
}
export function findCommonParent(element1, element2) {
    if (!element1 || !element2) {
        return null;
    }
    if (element1.contains(element2) || element1 === element2) {
        return element1.parentNode || element1;
    }
    if (element2.contains(element1)) {
        return element2.parentNode || element2;
    }
    const pathToRoot1 = [];
    let currentElement1 = element1;
    while (currentElement1) {
        pathToRoot1.push(currentElement1);
        currentElement1 = currentElement1.parentElement;
    }
    let currentElement2 = element2;
    while (currentElement2) {
        if (pathToRoot1.includes(currentElement2)) {
            return currentElement2;
        }
        currentElement2 = currentElement2.parentElement;
    }
    return null;
}
export function getScrollbarLine(prefixId) {
    return document.getElementById(`${SCROLL_BAR_LINE_ID}${prefixId}`);
}
export function getScrollbarContainer(prefixId) {
    return document.getElementById(`${SCROLL_BAR_CONTAINER_ID}${prefixId}`);
}
/**
 * Scroll progress 0–1 from the start of the scroller.
 * LTR uses scrollLeft / max. RTL uses Chromium's negative scrollLeft, or the
 * inverted positive origin used by some engines.
 */
export function scrollbarScrollProgress(scrollable) {
    const maxScroll = scrollable.scrollWidth - scrollable.clientWidth;
    if (maxScroll <= 0)
        return 0;
    const { scrollLeft } = scrollable;
    const isRtl = getComputedStyle(scrollable).direction === 'rtl';
    let progress;
    if (isRtl) {
        progress = scrollLeft <= 0 ? Math.abs(scrollLeft) / maxScroll : (maxScroll - scrollLeft) / maxScroll;
    }
    else {
        progress = scrollLeft / maxScroll;
    }
    return Math.min(1, Math.max(0, progress));
}
export function scrollbarAriaValueNow(scrollable) {
    return Math.round(scrollbarScrollProgress(scrollable) * (SCROLL_ARIA_VALUE_MAX - SCROLL_ARIA_VALUE_MIN) + SCROLL_ARIA_VALUE_MIN);
}
export function syncScrollbarAriaValue(scrollLine, scrollable) {
    if (!scrollLine || !scrollable)
        return;
    scrollLine.setAttribute('aria-valuenow', String(scrollbarAriaValueNow(scrollable)));
}
export { SCROLL_BAR_LINE_ID };
